import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/lib/query-keys";
import { fetchClinics } from "@/lib/clinics-api";

/**
 * Fetches the list of active clinics.
 * Returns [] when the feature flag is off.
 * Long staleTime — clinic list rarely changes.
 */
export function useClinics() {
  return useQuery({
    queryKey: queryKeys.clinics.all,
    queryFn: fetchClinics,
    staleTime: 5 * 60 * 1000,
  });
}
